import UploadIconSvg from "assets/icons/actions/upload.svg?react";
import UploadSaddleIconSvg from "assets/icons/actions/heart.svg?react";
import ChevronUpRightIconSvg from "assets/icons/actions/chevron-right.svg?react";
import ChevronDownRightIconSvg from "assets/icons/actions/chevron-down-right.svg?react";
import MapPinIconSvg from "assets/icons/actions/map-pin.svg?react";
import GlobeIconSvg from "assets/icons/actions/globe.svg?react";
import HeartIconSvg from "assets/icons/actions/fav-heart.svg?react";
import StoreIconSvg from "assets/icons/actions/store.svg?react";
import ChevronDownIconSvg from "assets/icons/actions/chevron-down.svg?react";
import ArrowUpIconSvg from "assets/icons/actions/Arrow-Up.svg?react";
import ShopCartIconSvg from "assets/icons/actions/shopping-cart.svg?react";
import EditIconSvg from "assets/icons/dashboard/edit.svg?react";
import TrashIconSvg from "assets/icons/dashboard/trash.svg?react";
import TRASH_ICON from "assets/icons/Trash_Icon.svg?react";
import SelectedHorseRadioSvg from "assets/icons/actions/selected-horse.svg?react";
import UnionIconSvg from "assets/icons/Union.svg?react";
import SaddleIconSvg from "assets/icons/saddleIcon.svg?react";
import SaddleTechIconSvg from "assets/icons/saddleTech.svg?react";
import AlgorithmSaddleSvg from "assets/icons/algorithm-saddle.svg?react";
import HorseIconSvg from "assets/icons/horse-saddle.svg?react";
import MobileDevIconSvg from "assets/icons/mobile-development.svg?react";
import SaddleSaleIconSvg from "assets/icons/saddle-sale.svg?react";
import OnlineShopIconSvg from "assets/icons/online-shopping.svg?react";
import ShopIconSvg from 'assets/icons/Shop.svg?react';
import cartIconAddSvg from 'assets/icons/shopping-cart-add.svg?.react';
import InstagramIconSvg from "assets/icons/social/instagram.svg?react";
import YoutubeIconSvg from "assets/icons/social/youtube.svg?react";
import LogOutIconSvg from "assets/icons/actions/log-out.svg?react";
import EditClientIconSvg from "assets/icons/actions/edit-client.svg?react";
import FacebookIconSvg from "assets/icons/social/facebook.svg?react";
import CalenderIconSvg from "assets/icons/actions/calendar.svg?react";
import JIconSvg from "assets/icons/social/j.svg?react";
import CameraIconSvg from "assets/icons/actions/camera.svg?react";
import SaddlePinIconSvg from "assets/icons/actions/saddle-pin.svg?react";
import AuthDealersPinIconSvg from "assets/icons/actions/authorized-map-pin.svg?react";
import MailIconSvg from "assets/icons/actions/mail-icon.svg?react";
import PhoneIconSvg from "assets/icons/actions/phone-icon.svg?react";
import AuthDealerPhoneIconSvg from "assets/icons/actions/phone-icon.svg?react";
import HomeIconSvg from "assets/icons/actions/home-icon.svg?react";
import ClientHomeIconSvg from "assets/icons/actions/client-home-icon.svg?react";
import ClientPhoneIconSvg from "assets/icons/actions/client-phone.svg?react";
import ClientMailIconSvg from "assets/icons/actions/client-mail.svg?react";
import ClientUserIconSvg from "assets/icons/actions/client-user.svg?react";
import ClientUploadIconSvg from "assets/icons/uploadImageIcon.svg?react";
import RadioUncheckedSvg from "assets/icons/actions/radio_unchecked.svg?react";
import RadioCheckedSvg from "assets/icons/actions/radio_checked.svg?react";
import HorseIconFailSvg from "assets/icons/notifications/simple-notification-hourse-fail-icon.svg?react";
import HorseIconSuccessSvg from "assets/icons/notifications/horse-notification-success.svg?react";
import DeleteIconSvg from "assets/icons/notifications/horse-delete-icon.svg?react";
import ChangePenIconSvg from "assets/icons/actions/change-pen-icon.svg?react";
export {
  StoreIconSvg,
  SaddleSaleIconSvg,
  ClientUploadIconSvg,
  ClientMailIconSvg,
  AuthDealerPhoneIconSvg,
  ClientPhoneIconSvg,
  ClientUserIconSvg,
  ClientHomeIconSvg,
  SaddlePinIconSvg,
  AuthDealersPinIconSvg,
  GlobeIconSvg,
  DeleteIconSvg,
  MailIconSvg,
  PhoneIconSvg,
  HomeIconSvg,
  EditClientIconSvg,
  CameraIconSvg,
  ChevronDownRightIconSvg,
  ChevronUpRightIconSvg,
  TrashIconSvg,
  EditIconSvg,
  ArrowUpIconSvg,
  LogOutIconSvg,
  ShopCartIconSvg,
  CalenderIconSvg,
  UploadIconSvg,
  UnionIconSvg,
  AlgorithmSaddleSvg,
  SaddleTechIconSvg,
  OnlineShopIconSvg,
  MobileDevIconSvg,
  ChevronDownIconSvg,
  SaddleIconSvg,
  HorseIconSvg,
  HeartIconSvg,
  InstagramIconSvg,
  YoutubeIconSvg,
  FacebookIconSvg,
  JIconSvg,
  RadioUncheckedSvg,
  ShopIconSvg,
  cartIconAddSvg,
  RadioCheckedSvg,
  HorseIconFailSvg,
  HorseIconSuccessSvg,
  SelectedHorseRadioSvg,
  ChangePenIconSvg,
  UploadSaddleIconSvg,
};
const StoreIcon = StoreIconSvg;
const CalenderIcon = CalenderIconSvg;
const EditIcon = EditIconSvg;
const TrashIcon = TrashIconSvg;
const ArrowUpIcon = ArrowUpIconSvg;
const ShopCartIcon = ShopCartIconSvg;
const UploadIcon = UploadIconSvg;
const UnionIcon = UnionIconSvg;
const SaddleTechIcon = SaddleTechIconSvg;
const MobileDevIcon = MobileDevIconSvg;
const OnlineShopIcon = OnlineShopIconSvg;
const HorseIcon = HorseIconSvg;
const AlgorithmSaddleIcon = AlgorithmSaddleSvg;
const SaddleIcon = SaddleIconSvg;
const HeartIcon = HeartIconSvg;
const InstagramIcon = InstagramIconSvg;
const YoutubeIcon = YoutubeIconSvg;
const FacebookIcon = FacebookIconSvg;
const MapPinIcon = MapPinIconSvg;
const AuthDealersPinIcon = AuthDealersPinIconSvg;
const JIcon = JIconSvg;
const RadioUnchecked = RadioUncheckedSvg;
const RadioChecked = RadioCheckedSvg;
const AuthDealerPhoneIcon = AuthDealerPhoneIconSvg;
const UploadSaddleIcon = UploadSaddleIconSvg;
export const SaddleSaleIcon = SaddleSaleIconSvg;
export const ClientHomeIcon = ClientHomeIconSvg;
export const ChevronDownRightIcon = ChevronDownRightIconSvg;
export const ChevronUpRightIcon = ChevronUpRightIconSvg;
export const ChevronDownIcon = ChevronDownIconSvg;
export const HorseIconFail = HorseIconFailSvg;
export const GlobeIcon = GlobeIconSvg;
export const ClientUploadIcon = ClientUploadIconSvg;
export const ClientMailIcon = ClientMailIconSvg;
export const ClientPhoneIcon = ClientPhoneIconSvg;
export const ClientUserIcon = ClientUserIconSvg;
export const EditClientIcon = EditClientIconSvg;
export const CameraIcon = CameraIconSvg;
export const HorseIconDelete = DeleteIconSvg;
export const LogOutIcon = LogOutIconSvg;
export const SaddlePinIcon = SaddlePinIconSvg;
export const MailIcon = MailIconSvg;
export const PhoneIcon = PhoneIconSvg;
export const HomeIcon = HomeIconSvg;
export const HorseIconSuccess = HorseIconSuccessSvg;
export const SelectedHorseRadioIcon = SelectedHorseRadioSvg;
export const ChangePenIcon = ChangePenIconSvg;
export {
  StoreIcon,
  EditIcon,
  CalenderIcon,
  MapPinIcon,
  AuthDealersPinIcon,
  TrashIcon,
  ArrowUpIcon,
  AuthDealerPhoneIcon,
  ShopCartIcon,
  UploadIcon,
  UnionIcon,
  HorseIcon,
  MobileDevIcon,
  OnlineShopIcon,
  AlgorithmSaddleIcon,
  SaddleIcon,
  SaddleTechIcon,
  HeartIcon,
  InstagramIcon,
  YoutubeIcon,
  FacebookIcon,
  JIcon,
  RadioUnchecked,
  RadioChecked,
  UploadSaddleIcon,
  TRASH_ICON
};







